import React, { useState, useEffect } from 'react'
import ReactSelect from 'react-select'
import styles from './WidthInput.module.css'
import CustomNumber from '../../../../../../../components/CustomNumber/CustomNumber'

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    background: 'var(--white)',
    borderColor: 'var(--washed-gray)',
    minHeight: '28px',
    height: '28px',
    boxShadow: state.isFocused ? null : null,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '28px',
    padding: '0 6px',
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px',
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1
    const transition = 'opacity 300ms'

    return {
      ...provided,
      opacity,
      transition,
      color: 'var(--dark-gray)',
      fontFamily: 'var(--sans-serif)', // Changer la police du texte du singleValue
      fontSize: 'var(--size-font-input)', // Changer la taille du texte du singleValue
    }
  },
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? 'var(--darkened-background)'
      : 'var(--white)', // Changer la couleur d'arrière-plan de l'option
    color: state.isFocused ? 'var(--dark-gray)' : 'var(--dark-gray)', // Changer la couleur du texte de l'option
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: 'var(--white)', // Changer la couleur de fond du menu déroulant
  }),
  indicatorSeparator: (state) => ({
    display: 'none',
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: '28px',
  }),
}

const WidthInput = ({ name, value, onChange }) => {
  const [isCustomSelected, setIsCustomSelected] = useState(false)
  const [customWidth, setCustomWidth] = useState(200)

  const [unit, setUnit] = useState('px')

  useEffect(() => {
    if (value.endsWith('px') || value.endsWith('%')) {
      setIsCustomSelected(true)
      setCustomWidth(parseFloat(value))
      setUnit(value.endsWith('px') ? 'px' : '%')
    } else {
      setIsCustomSelected(false)
    }
  }, [value])

  const options = [
    { value: 'auto', label: 'Auto' },
    { value: 'fit-content', label: 'Taille du contenu' },
    { value: 'px', label: 'Pixels (px)' },
    { value: '%', label: 'Pourcentage (%)' },
  ]

  const handleSelectChange = (selectedOption) => {
    if (
      selectedOption.value === 'auto' ||
      selectedOption.value === 'fit-content'
    ) {
      setIsCustomSelected(false)
      onChange({ target: { name, value: selectedOption.value } })
    } else if (selectedOption.value === 'px' || selectedOption.value === '%') {
      setIsCustomSelected(true)
      setUnit(selectedOption.value)
      let newWidth = customWidth
      if (selectedOption.value === '%' && customWidth > 100) {
        newWidth = 100
        setCustomWidth(newWidth)
      }
      onChange({
        target: { name, value: `${newWidth}${selectedOption.value}` },
      })
    }
  }

  const handleCustomWidthChange = (event) => {
    let inputValue = parseFloat(event.target.value)

    if (unit === '%' && inputValue > 100) {
      inputValue = 100
    }

    setCustomWidth(inputValue)
    onChange({
      target: {
        name: name,
        value: `${inputValue}${unit}`,
      },
    })
  }

  let selectedOption
  if (isCustomSelected) {
    selectedOption = options.find((option) => option.value === unit)
  } else {
    selectedOption =
      options.find((option) => option.value === value) || options[0]
  }
  return (
    <div className={styles.container}>
      <ReactSelect
        value={selectedOption}
        onChange={handleSelectChange}
        options={options}
        styles={customStyles}
      />
      {isCustomSelected && (
        <CustomNumber
          name={`${name}-custom`}
          value={customWidth}
          onChange={handleCustomWidthChange}
          min={0}
          max={unit === '%' ? 100 : undefined} // Si l'unité est %, la limite max est 100. Sinon, pas de limite max.
          step={1}
        />
      )}
    </div>
  )
}

export default WidthInput
